<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>{{ title }}</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="onClose">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<ApplicantSendOff
				v-if="isTypeApplicant"
				v-model="applicantSendOffData"
				:is-anonymous="!customerIsDefined"
				:customer="customer"
			/>
			<CustomerSendOff
				v-else
				v-model="customerSendOffData"
				:disclosed-data="disclosedData"
				:pseudonym="pseudonym"
			/>
		</main>
		<footer>
			<Button
				text="Jetzt verabschieden"
				class="mt-2"
				icon="checkmark"
				:disabled="!sendOffDataValid || sendingRequest"
				:loading="sendingRequest"
				@click="executeSendOff"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY, TYPE_APPLICANT} from "@/store/job-result/send-off";
import Icon from "@/vue/icon/Icon";
import CustomerSendOff from "@/vue/communication/CustomerSendOff"
import ApplicantSendOff from "@/vue/communication/conversation/ApplicantSendOff";
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import Modify, {ACTION_SEND_OFF} from "@/api/communication/appointment/Modify";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Reply, {ACTION_SENDOFF} from "@/api/communication/conversation/message/Reply";

export default {

	components: {
		Icon,
		CustomerSendOff,
		ApplicantSendOff,
		Button,
	},

	data ()
	{
		return {
			applicantSendOffData: undefined,
			customerSendOffData: undefined,
			sendingRequest: false,
		};
	},

	computed: {
		...mapState('jobResult/sendOff', [
			'show',
			'type',
			'appointment',
			'message',
			'applicantData',
			'customerData'
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		customer ()
		{
			return this.applicantData?.customer;
		},
		customerIsDefined ()
		{
			return isDefined(this.customer);
		},
		disclosedData ()
		{
			return this.customerData?.disclosedData;
		},
		pseudonym ()
		{
			return this.customerData?.pseudonym;
		},
		isTypeApplicant ()
		{
			return this.type === TYPE_APPLICANT;
		},
		title ()
		{
			return this.isTypeApplicant
				? 'Bewerbung zurückziehen'
				: 'Verabschieden';
		},
		sendOffDataValid ()
		{
			return this.isTypeApplicant
				? isDefined(this.applicantSendOffData)
				: isDefined(this.customerSendOffData);
		}
	},

	methods: {
		...mapActions('jobResult/sendOff', [
			'close'
		]),
		async executeSendOff ()
		{
			this.sendingRequest = true;

			try
			{
				if (this.appointment)
				{
					const modify = new Modify()
						.setAppointmentId(this.appointment.id)
						.setAction(ACTION_SEND_OFF);

					if (this.isTypeApplicant)
					{
						modify.setApplicantSendOffData(this.applicantSendOffData);
					}
					else
					{
						modify.setCustomerSendOffData(this.customerSendOffData);
					}

					await modify.call();
				}
				else // message
				{
					const reply = new Reply()
						.setMessageId(this.message.id)
						.setAction(ACTION_SENDOFF);

					if (this.isTypeApplicant)
					{
						reply.setCustomerUninterestingType(this.applicantSendOffData.customerUninterestingType);
					}
					else
					{
						reply.setCustomerSendOffData(this.customerSendOffData);
					}

					await reply.call();
				}

				await this.onClose({
					sentOff: true
				});
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		},
		onClose (data)
		{
			this.applicantSendOffData = undefined;
			this.customerSendOffData = undefined;

			this.close(data);
		}
	}
}
</script>
